import { createFileRoute } from "@tanstack/react-router";
import { Bell } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { NotificationList } from "@/features/notifications/modules/notification-list/notification-list";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/notifications/")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.notifications_title(),
    };
  },
});

function RouteComponent() {
  return (
    <PageShell icon={Bell} title={m.notifications_title()} description={m.notifications_page_description()}>
      <NotificationList />
    </PageShell>
  );
}
